module.exports = __webpack_public_path__ + "static/media/W400.f52ddd5e.jpg";